import {Component, Output, EventEmitter, Input} from '@angular/core';

/*##################################################################################* 
 * COMPOSANT SPRO : spro-button
 * 
 * DESCRIPTION : Bouton qui contient un libellé traduit (et pas d’icône)
 * 
 ##################################################################################*/

@Component({
  selector: 'spro-button',
  template: `
    <button #anchor
            [class]="w_class"
            [type]="w_type"
            [title]="proc_get_popup() | translate"
            [disabled]="!f_actif"
            (click)="proc_click()"
    >
      <span [class]="w_icone" *ngIf="w_icone!=''"></span>
      {{ w_label | translate }}
    </button>

    <kendo-popup [popupClass]="'content popup'" [anchor]="anchor" (anchorViewportLeave)="f_show_popup = false" *ngIf="f_show_popup">
        <div [innerHTML]="w_popup | translate"></div>
    </kendo-popup>
  `,
})
export class spro_cls_button {

  /** Type du bouton a afficher */
  @Input() w_type: string = "button";
  /** Label contenant la classe utilisé pour le style du bouton */
  @Input() w_class: string = "k-button";
  /** Label contenant la traduction du bouton */
  @Input() w_label: string;
  /** Icone ou vide pour ne pas l'afficher */
  @Input() w_icone: string = "";
  /** Texte de la popup */
  @Input() w_popup: string = null;
  /** Pour désactiver le bouton */
  @Input() f_actif: boolean = true;
  /** Pour désactiver la popup */
  @Input() f_action_popup: boolean = false;

  /** Déclaration événement sur click */
  @Output() e_click: EventEmitter<any> = new EventEmitter();

  /** Flag pour l'affichage de la popup */
  public f_show_popup: boolean = false;

  /**
   * Evénements sur click
   */
  public proc_click(): void {
    if (this.f_action_popup) {
      this.f_show_popup = !this.f_show_popup;
      return;
    }
    this.e_click.emit();
  }

  /**
   * Retourne le libellé de la popup
   */
  public proc_get_popup(): string {
    if (this.w_popup == null)
      return this.w_label;
    return this.w_popup.replace(/<br>|<br\/>|<br \/>/gi, "\n");
  }
}


// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/buttons/spro-button/spro-button.component.ts